const initialState = {
  category: null,
  loading: false,
  error: null,
};

export const homeCategoryReducer = (state = initialState, action) => {
  switch (action.type) {

    // Add
    case "HOME_CATEGORY_ADD_REQUEST":
      return { ...state, loading: true, error: null };

    case "HOME_CATEGORY_ADD_SUCCESS":
      return { ...state, loading: false, error: null };

    case "HOME_CATEGORY_ADD_FAIL":
      return { ...state, loading: false, error: action.payload };

    // Update
    case "HOME_CATEGORY_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };

    case "HOME_CATEGORY_UPDATE_SUCCESS":
      return { ...state, loading: false, error: null };

    case "HOME_CATEGORY_UPDATE_FAIL":
      return { ...state, loading: false, error: action.payload };

    // View
    case "HOME_CATEGORY_VIEW_REQUEST":
      return { ...state, loading: true, error: null };

    case "HOME_CATEGORY_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        category: action.payload.data || null,
        error: null,
      };

    case "HOME_CATEGORY_VIEW_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        category: null,
      };

    case "CLEAR_HOME_CATEGORY_ERRORS":
      return { ...state, error: null };

    default:
      return state;
  }
};